import { Component, Inject, ViewChild } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
  ProcessBaseDialogData,
  ProcessBaseDialogResult,
  ProcessBaseFormComponent
} from "./process-base-form/process-base-form.component";

@Component({
  selector: 'app-process-base-dialog',
  templateUrl: './process-base-dialog.component.html',
  styleUrls: ['./process-base-dialog.component.scss']
})
export class ProcessBaseDialogComponent {

  @ViewChild('formComponent') formComponent!: ProcessBaseFormComponent;
  savingInProgress = false;

  constructor(
    public dialogRef: MatDialogRef<ProcessBaseDialogComponent, ProcessBaseDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ProcessBaseDialogData
  ) {}

  public static openDialog(
    dialog: MatDialog,
    data: ProcessBaseDialogData,
    resultCallback: (result?: ProcessBaseDialogResult) => void
  ) {
    const dialogRef = dialog.open(ProcessBaseDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result: ProcessBaseDialogResult) => {
      resultCallback(result);
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onFormFinished(result?: ProcessBaseDialogResult) {
    this.dialogRef.close(result);
  }

  get readonly(): boolean { return this.data.readonly; }
  get edit(): boolean { return !this.readonly && this.data.process !== undefined; }
  get create(): boolean { return !this.readonly && this.data.process === undefined; }

  getTitleKey(): string {
    if (this.readonly) return 'PROCESS_DETAIL';
    if (this.edit) return 'PROCESS_EDIT';
    return 'PROCESS_CREATE';
  }
}
